module.exports = "<p>\n  config-controls-page works!\n</p>\n"